'use client';

import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
import { useEffect, useState } from 'react';
export function FooterFooter() {
  const $ = _c(8);
  const [currentYear, setCurrentYear] = useState(null);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      setCurrentYear(new Date().getFullYear());
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  const yearDisplay = currentYear ?? "2025";
  let t2;
  if ($[2] !== yearDisplay) {
    t2 = <li>© {yearDisplay} Better World Films LLC</li>;
    $[2] = yearDisplay;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <li><Link href="/terms" className="transition-all duration-300 hover:underline">{"Terms & Conditions"}</Link></li>;
    t4 = <li><Link href="/privacy" className="transition-all duration-300 hover:underline">Privacy Policy</Link></li>;
    $[4] = t3;
    $[5] = t4;
  } else {
    t3 = $[4];
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t2) {
    t5 = <div className="mt-20 font-medium text-xs tracking-[0.02em]"><ul className="flex w-full flex-row justify-between gap-1.5 opacity-60 md:gap-6">{t2}{t3}{t4}</ul></div>;
    $[6] = t2;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
}